import { defaultApiServer } from './config';
import jsonapiClient from './ra-jsonapi-client';

const requestInit: RequestInit = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    },
    mode: 'cors',
}

const settings = {
    ...requestInit,
    total: 'record_count',
}

const apiServer = defaultApiServer();

const defaultProvider: any = jsonapiClient(`${apiServer}/admin`, settings);

const customProvider = async (type: string, resource: string, params: any) => {
    try {
        let res: any;

        switch (type) {
            case 'CREATE':
                res = await handleUploads(type, resource, params);
            break;

            default:
                res = await defaultProvider(type, resource, params)
            break;
        }

        return res;

    } catch (error: any) {
        const errorObj = getErrorObject(error);
        throw errorObj;
    }
}

interface ErrorDataInterface {
    status: string;
    title: string;
    detail: string;
}

const getErrorObject = (error: any) => {
    console.log({error})
    if (typeof error.message === 'string') {
        return {
            status: 500,
            message: error.message,
        }
    }

    const apiError: ErrorDataInterface = error.message && error.message.errors && error.message.errors[0] ? error.message.errors[0] : {};
    return {
        status: apiError.status || 500,
        message: apiError.detail || '',
    }
}

const dataProvider = customProvider;

const handleUploads = async (type: 'CREATE', resource: string, params: any) => {
    // console.log({resource, params})

    if (typeof params.data.media === 'undefined') {
        return defaultProvider('CREATE', resource, params);
    }

    // Freshly dropped pictures are File objects and must be converted to base64 strings
    const newPictures = [params.data.media].filter(
        (p: any) => p.rawFile instanceof File
    );
    const formerPictures = [params.data.media].filter(
        (p: any) => !(p.rawFile instanceof File)
    );

    const base64Pictures = await Promise.all(newPictures.map(convertFileToBase64));
    const transformedNewPictures = base64Pictures.map(media64 => ({
        dataUri: media64,
        title: `${params.data.title}`,
    }));
    const newParams = {
        data: {
            ...params.data,
            blob: [
                ...transformedNewPictures,
                ...formerPictures,
            ],
        },
    };

    if (type === 'CREATE') {
        return defaultProvider('CREATE', resource, newParams);
    } else {
        return defaultProvider('UPDATE', resource, newParams);
    }
}

/**
 * Convert a `File` object returned by the upload input into a base 64 string.
 * That's not the most optimized way to store images in production, but it's
 * enough to illustrate the idea of data provider decoration.
 */
 const convertFileToBase64 = (file: any) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;

        reader.readAsDataURL(file.rawFile);
    });

export default dataProvider;